import React, { useEffect, useState, useCallback, useMemo, useRef } from "react";
import _ from "lodash";
import moment from "moment";
import { useSelector } from "react-redux";
// @material-ui/core components
import {
  Box,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogTitle,
  Fab,
  FormControlLabel,
  IconButton,
  List,
  ListItem,
  ListItemText,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
// core components
import GridItem from "../../components/Grid/GridItem.js";
import GridContainer from "../../components/Grid/GridContainer.js";
import CustomInput from "../../components/CustomInput/CustomInput.js";
import Button from "../../components/CustomButtons/Button.js";
import Card from "../../components/Card/Card.js";
import CardHeader from "../../components/Card/CardHeader.js";
import CardBody from "../../components/Card/CardBody.js";
import { invTemp as invoiceTemplate } from "../../assets/html/invTemp";
import { challan1Template } from "../../assets/html/challan1Template";
import { challan2Template } from "../../assets/html/challan2Template";
import { challan3Template } from "../../assets/html/challan3Template";
import { dataURItoBlob, htmlTemplateToDataString, sendWhatsAppMessage } from "../../utils";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import Grid from "@material-ui/core/Grid";
import axios from "axios";
import {
  CreateBulkOrderAPI,
  GetAllAccountsWithLightweightAPI,
  GetAllProductMastersWithLightweightAPI,
} from "../../config/api";
import { toast } from "react-toastify";
import { FilePicker } from "../../components/common/FilePicker.js";

const styles = {
  formControl: {
    paddingBottom: "10px",
    margin: "27px 0 0 0",
    position: "relative",
    verticalAlign: "unset",
  },
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0",
  },
  cardTitleWhite: {
    flex: 1,
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
  },
};

const useStyles = makeStyles(styles);

const glassTypes = ["Cr", "Gi", "P"];
const frameSections = ["3pc", "Supra", "Full Frame"];
const fittingHeightOptions = ["Regular", "Short"];

let invoiceTemplates = [
  {
    label: "Invoice",
    value: "invoice",
  },
  {
    label: "Challan 1",
    value: "challan1",
  },
  {
    label: "Challan 2",
    value: "challan2",
  },
  {
    label: "Challan 3",
    value: "challan3",
  },
];

const columns = [
  { id: "party", label: "Party" },
  { id: "product", label: "Product" },
  { id: "tint", label: "Tint", format: (value) => (value ? "Yes" : "No") },
  { id: "rSph", label: "Right Sph" },
  { id: "rCyl", label: "Right Cyl" },
  { id: "rAxis", label: "Right Axis" },
  { id: "rAddition", label: "Right Add" },
  { id: "lSph", label: "Left Sph" },
  { id: "lCyl", label: "Left Cyl" },
  { id: "lAxis", label: "Left Axis" },
  { id: "lAddition", label: "Left Add" },
  { id: "action", label: "Action" },
];
export default function PrescriptionOrderAdd(props) {
  const classes = useStyles();
  const theme = useTheme();

  let userInfo = useSelector((state) => state.userReducer.userInfo);
  let authToken = useSelector((state) => state.userReducer.authToken);

  const { open, close, fetchData } = props;
  const [selectedItem, setSelectedItem] = useState(null);
  const fullScreen = useMediaQuery(theme.breakpoints.down("xs"));

  const [quantity, setQuantity] = useState("");
  const [lab, setLab] = useState(null);
  const [productType, setProductType] = useState(null);
  const [productName, setProductName] = useState("");
  const [product, setProduct] = useState(null);
  const [party, setParty] = useState(null);
  const [partyRef, setPartyRef] = useState("");
  const [partyMobileNo, setPartyMobileNo] = useState("");
  const [clientName, setClientName] = useState("");
  const [glassType, setGlassType] = useState("");
  const [dia, setDia] = useState("");
  const [index, setIndex] = useState("");
  const [fittingHeight, setFittingHeight] = useState("");
  const [coat, setCoat] = useState("");
  const [tint, setTint] = useState(false);
  const [sphRight, setSphRight] = useState("");
  const [sphLeft, setSphLeft] = useState("");
  const [cylLeft, setCylLeft] = useState("");
  const [cylRight, setCylRight] = useState("");
  const [axisRight, setAxisRight] = useState("");
  const [axisLeft, setAxisLeft] = useState("");
  const [addRight, setAddRight] = useState("");
  const [addLeft, setAddLeft] = useState("");
  const [prism, setPrism] = useState("");
  const [pd, setPd] = useState("");
  const [ed, setEd] = useState("");
  const [frameSection, setFrameSection] = useState("");

  const [note, setNote] = useState("");
  const [users, setUsers] = useState([]);
  const [labs, setLabs] = useState([]);
  const [productTypes, setProductTypes] = useState([]);
  const [productNames, setProductNames] = useState([]);
  const [products, setProducts] = useState([]);
  const [coatings, setCoatings] = useState([]);
  const [items, setItems] = useState([]);
  const [indexOptions, setIndexOptions] = useState([]);
  const [showInvoiceSelectionDialog, setShowInvoiceSelectionDialog] =
    useState(false);
  const [categoryImage, setCategoryImage] = useState([]);
  const [productDetails, setProductDetails] = useState(null);

  // Loading states
  const [loadingLabs, setLoadingLabs] = useState(false);
  const [loadingProductTypes, setLoadingProductTypes] = useState(false);
  const [loadingProductNames, setLoadingProductNames] = useState(false);
  const [loadingProducts, setLoadingProducts] = useState(false);
  const [loadingIndexes, setLoadingIndexes] = useState(false);
  const [loadingCoatings, setLoadingCoatings] = useState(false);
  const [loadingFinalProduct, setLoadingFinalProduct] = useState(false);
  const [loadingProductDetails, setLoadingProductDetails] = useState(false);
  const savingOrdersRef = useRef(false);
  const [isSavingOrders, setIsSavingOrders] = useState(false);

  const _getUsers = useCallback(async () => {
    try {
      const res = await axios.get(GetAllAccountsWithLightweightAPI(userInfo.entity), {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      const saleUsers = res.data.accounts.filter(account => account.partyType === "sale");
      setUsers(saleUsers);
    } catch (e) {
      if (process.env.NODE_ENV === 'development') {
        console.error("Error fetching users:", e);
      }
      toast.error("Failed to fetch users. Please try again.", {
        position: "top-center",
        autoClose: 3000,
        theme: "light",
      });
    }
  }, [userInfo.entity, authToken]);

  // Fetch labs when dialog opens
  const _getLabs = useCallback(async () => {
    if (!open || !userInfo.entity) return;

    setLoadingLabs(true);
    try {
      const filters = JSON.stringify({ status: "Active" });
      const url = `${GetAllProductMastersWithLightweightAPI(userInfo.entity)}&fieldName=lab&filters=${encodeURIComponent(filters)}`;

      const res = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });

      // Response structure: res.data.fields.lab.uniqueValues - array of strings
      const labsData = res.data?.fields?.lab?.uniqueValues || [];
      const formattedLabs = labsData.map(labName => ({ lab: labName }));
      setLabs(formattedLabs);
    } catch (e) {
      if (process.env.NODE_ENV === 'development') {
        console.error("Error fetching labs:", e);
      }
      toast.error("Failed to fetch labs. Please try again.", {
        position: "top-center",
        autoClose: 3000,
        theme: "light",
      });
    } finally {
      setLoadingLabs(false);
    }
  }, [open, userInfo.entity, authToken]);

  // Fetch productTypes when lab is selected
  const _getProductTypes = useCallback(async () => {
    if (!lab || !userInfo.entity) {
      setProductTypes([]);
      setProductNames([]);
      setProductType(null);
      setProductName("");
      setProduct(null);
      setCoat(null);
      setIndex("");
      setProductDetails(null);
      return;
    }

    setLoadingProductTypes(true);
    try {
      const filters = JSON.stringify({ lab: lab.lab, status: "Active" });
      const url = `${GetAllProductMastersWithLightweightAPI(userInfo.entity)}&fieldName=productType&filters=${encodeURIComponent(filters)}`;

      const res = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });

      // Response structure: res.data.fields.productType.uniqueValues - array of strings
      const productTypesData = res.data?.fields?.productType?.uniqueValues || [];
      const formattedProductTypes = productTypesData.map(productTypeName => ({ productType: productTypeName }));
      setProductTypes(formattedProductTypes);

      // Reset dependent fields
      setProductType(null);
      setProductName("");
      setProductNames([]);
      setProduct(null);
      setProducts([]);
      setCoat(null);
      setIndex("");
      setIndexOptions([]);
      setCoatings([]);
      setProductDetails(null);
    } catch (e) {
      if (process.env.NODE_ENV === 'development') {
        console.error("Error fetching product types:", e);
      }
      toast.error("Failed to fetch product types. Please try again.", {
        position: "top-center",
        autoClose: 3000,
        theme: "light",
      });
      setProductTypes([]);
    } finally {
      setLoadingProductTypes(false);
    }
  }, [lab, userInfo.entity, authToken]);

  // Fetch productNames when productType is selected
  const _getProductNames = useCallback(async () => {
    if (!lab || !productType || !userInfo.entity) {
      setProductNames([]);
      setProductName("");
      setIndexOptions([]);
      setIndex("");
      setCoatings([]);
      setCoat("");
      setProductDetails(null);
      return;
    }

    setLoadingProductNames(true);
    try {
      const filters = JSON.stringify({
        lab: lab.lab,
        status: "Active",
        productType: productType.productType
      });
      const url = `${GetAllProductMastersWithLightweightAPI(userInfo.entity)}&fieldName=productName&filters=${encodeURIComponent(filters)}`;

      const res = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });

      // Response structure: res.data.fields.productName.uniqueValues - array of strings
      const productNamesData = res.data?.fields?.productName?.uniqueValues || [];
      setProductNames(productNamesData);

      // Reset dependent fields
      setProductName("");
      setIndexOptions([]);
      setIndex("");
      setCoatings([]);
      setCoat("");
      setProductDetails(null);
    } catch (e) {
      if (process.env.NODE_ENV === 'development') {
        console.error("Error fetching product names:", e);
      }
      toast.error("Failed to fetch product names. Please try again.", {
        position: "top-center",
        autoClose: 3000,
        theme: "light",
      });
      setProductNames([]);
    } finally {
      setLoadingProductNames(false);
    }
  }, [lab, productType, userInfo.entity, authToken]);

  // Fetch indexes when productName is selected
  const _getIndexes = useCallback(async () => {
    if (!lab || !productType || !productName || productName.trim() === "" || !userInfo.entity) {
      setIndexOptions([]);
      setIndex("");
      setCoatings([]);
      setCoat("");
      setProductDetails(null);
      return;
    }

    setLoadingIndexes(true);
    try {
      const filters = JSON.stringify({
        lab: lab.lab,
        status: "Active",
        productType: productType.productType,
        productName: productName
      });
      const url = `${GetAllProductMastersWithLightweightAPI(userInfo.entity)}&fieldName=index&filters=${encodeURIComponent(filters)}`;

      const res = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });

      // Response structure: res.data.fields.index.uniqueValues - array of strings
      const indexesData = res.data?.fields?.index?.uniqueValues || [];
      if (process.env.NODE_ENV === 'development') {
        console.log("Indexes response:", res.data);
        console.log("Indexes data:", indexesData);
      }
      setIndexOptions(indexesData);

      // Reset dependent fields
      setIndex("");
      setCoatings([]);
      setCoat("");
      setProductDetails(null);
    } catch (e) {
      if (process.env.NODE_ENV === 'development') {
        console.error("Error fetching indexes:", e);
        console.error("Error response:", e.response?.data);
      }
      toast.error("Failed to fetch indexes. Please try again.", {
        position: "top-center",
        autoClose: 3000,
        theme: "light",
      });
      setIndexOptions([]);
    } finally {
      setLoadingIndexes(false);
    }
  }, [lab, productType, productName, userInfo.entity, authToken]);

  // Fetch coatings when index is selected
  const _getCoatings = useCallback(async () => {
    if (!lab || !productType || !productName || !index || !userInfo.entity) {
      setCoatings([]);
      setCoat("");
      setProductDetails(null);
      return;
    }

    setLoadingCoatings(true);
    try {
      const filters = JSON.stringify({
        lab: lab.lab,
        status: "Active",
        productType: productType.productType,
        productName: productName,
        index: index
      });
      const url = `${GetAllProductMastersWithLightweightAPI(userInfo.entity)}&fieldName=coating&filters=${encodeURIComponent(filters)}`;

      const res = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });

      // Response structure: res.data.fields.coating.uniqueValues - array of strings
      const coatingsData = res.data?.fields?.coating?.uniqueValues || [];
      const formattedCoatings = coatingsData.map(coatingName => ({ coating: coatingName }));
      setCoatings(formattedCoatings);

      // Reset dependent fields
      setCoat("");
      setProductDetails(null);
    } catch (e) {
      if (process.env.NODE_ENV === 'development') {
        console.error("Error fetching coatings:", e);
      }
      toast.error("Failed to fetch coatings. Please try again.", {
        position: "top-center",
        autoClose: 3000,
        theme: "light",
      });
      setCoatings([]);
    } finally {
      setLoadingCoatings(false);
    }
  }, [lab, productType, productName, index, userInfo.entity, authToken]);

  // Fetch final product when coating is selected
  const _getFinalProduct = useCallback(async () => {
    if (!lab || !productType || !productName || !index || !coat || !userInfo.entity) {
      setProductDetails(null);
      return;
    }

    setLoadingFinalProduct(true);
    try {
      const filters = JSON.stringify({
        lab: lab.lab,
        status: "Active",
        productType: productType.productType,
        productName: productName,
        index: index,
        coating: coat.coating || coat
      });
      const url = `${GetAllProductMastersWithLightweightAPI(userInfo.entity)}&fieldName=finalProduct&filters=${encodeURIComponent(filters)}`;

      const res = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });

      // Response structure: res.data.product - single product object
      const productData = res.data?.product;
      setProductDetails(productData);
    } catch (e) {
      if (process.env.NODE_ENV === 'development') {
        console.error("Error fetching final product:", e);
      }
      toast.error("Failed to fetch product details. Please try again.", {
        position: "top-center",
        autoClose: 3000,
        theme: "light",
      });
      setProductDetails(null);
    } finally {
      setLoadingFinalProduct(false);
    }
  }, [lab, productType, productName, index, coat, userInfo.entity, authToken]);


  useEffect(() => {
    // Only fetch users when modal is open
    if (open && userInfo?.entity) {
      _getUsers();
    }
  }, [open, _getUsers, userInfo?.entity]);

  useEffect(() => {
    _getLabs();
  }, [_getLabs]);

  useEffect(() => {
    _getProductTypes();
  }, [_getProductTypes]);

  useEffect(() => {
    _getProductNames();
  }, [_getProductNames]);

  useEffect(() => {
    _getIndexes();
  }, [_getIndexes]);

  useEffect(() => {
    _getCoatings();
  }, [_getCoatings]);

  useEffect(() => {
    _getFinalProduct();
  }, [_getFinalProduct]);

  // Auto-populate fields from product details
  useEffect(() => {
    if (productDetails) {
      // Auto-populate dia if available and not already set
      if (productDetails.dia) {
        setDia(prevDia => prevDia || productDetails.dia);
      }
    }
  }, [productDetails]);

  //   async function _onSave() {
  //     try {
  //       if (items.length === 0) {
  //         toast.error("Please add a Presciption order", {
  //           position: "top-center",
  //           autoClose: 1500,
  //           hideProgressBar: false,
  //           closeOnClick: true,
  //           pauseOnHover: true,
  //           draggable: true,
  //           progress: undefined,
  //           theme: "light",
  //         });
  //         return;
  //       }
  //       // let formData = new FormData();
  //       // if (!_.isEmpty(categoryImage)) {
  //       //   formData.append("image", categoryImage[0].path);
  //       // }
  //       // formData.append("data", items)
  //       // formData.append("entity", userInfo.entity)

  //       let formData = new FormData();
  // // if (!_.isEmpty(categoryImage)) {
  // //   formData.append("image", categoryImage[0].path);
  // // }
  // if(categoryImage.length > 0){
  //   console.log("doin it", typeof items)
  //   formData.append("image", categoryImage[0].path);
  //   formData.append("imageName", categoryImage[0].name);
  // }
  // // items.push("image" , categoryImage[0].path)
  // // console.log(">>>>items",items)
  // // Serialize items array to a JSON string
  // formData.append("data", JSON.stringify(items));
  // formData.append("entity", userInfo.entity);
  //       for (const value of formData.values()) {
  //         console.log(value);
  //       }
  //       let res = await axios.post(
  //         CreateBulkOrderAPI(),
  //         // {

  //         //   // data: items,
  //         //   // entity: userInfo.entity,
  //         //   // ...items, entity: userInfo.entity,
  //         // },
  //         formData,
  //         {
  //           headers: {
  //             Authorization: `Bearer ${authToken}`,
  //           "Content-Type": "multipart/form-data",
  //           },
  //         }
  //       );
  //       setItems([]);
  //       toast.success("Successfully Added!", {
  //         position: "top-center",
  //         autoClose: 1500,
  //         hideProgressBar: false,
  //         closeOnClick: true,
  //         pauseOnHover: true,
  //         draggable: true,
  //         progress: undefined,
  //         theme: "light",
  //       });
  //       close();
  //       fetchData();
  //     } catch (e) {
  //       // console.log("err:", e);
  //       // toast.error(("Something went wrong, Please Contact Admin"), {
  //       //   position: "top-center",
  //       //   autoClose: 1500,
  //       //   hideProgressBar: false,
  //       //   closeOnClick: true,
  //       //   pauseOnHover: true,
  //       //   draggable: true,
  //       //   progress: undefined,
  //       //   theme: "light",
  //       // });
  //     }
  //   }

  const _onSave = useCallback(async () => {
    if (savingOrdersRef.current) return;
    try {
      if (!Array.isArray(items) || items.length === 0) {
        toast.error("Please add a Prescription order", {
          position: "top-center",
          autoClose: 1500,
          theme: "light",
        });
        return;
      }

      // Balance Lock check (admin-defined)
      for (const o of items) {
        const p = o?.party;
        const lock = Number(p?.balanceLock || 0);
        if (lock > 0) {
          const current = Number(p?.runningChallanBalance ?? p?.runningBillBalance ?? 0);
          const projected = current + Number(o?.orderAmount || 0);
          if (projected > lock) {
            toast.error(
              `Balance locked for ${p?.accountName || "this account"}. Limit: ${lock}, Projected: ${Math.round(projected)}`,
              { position: "top-center", autoClose: 3000, theme: "light" }
            );
            return;
          }
        }
      }

      if (!authToken) {
        toast.error("Authentication error. Please log in again.", {
          position: "top-center",
          autoClose: 3000,
          theme: "light",
        });
        return;
      }

      savingOrdersRef.current = true;
      setIsSavingOrders(true);

      const CHUNK_SIZE = 20;
      const itemChunks = [];

      for (let i = 0; i < items.length; i += CHUNK_SIZE) {
        itemChunks.push(items.slice(i, i + CHUNK_SIZE));
      }

      for (const chunk of itemChunks) {
        const formData = new FormData();
        formData.append("entity", userInfo.entity);

        chunk.forEach((item, index) => {
          const orderData = {
            orderType: "Prescription",
            createdBy: userInfo._id,
            createdByName: userInfo.name,
            orderDetail: item.orderDetail,
            orderAmount: item.orderAmount,
            orderAdminStatus: "Confirmed",
            quantity: item.quantity,
            price: item.price,
            party: item.party,
            shippingAddress: item.shippingAddress || {},
            imageName: item.image ? item.image.name : "noimg",
          };

          formData.append(`orders[${index}]`, JSON.stringify(orderData));
          formData.append("check", true);

          if (item.image) {
            formData.append(`image`, item.image);
          }
        });

        await axios.post(CreateBulkOrderAPI(), formData, {
          headers: {
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "multipart/form-data",
          },
        });

        await new Promise((resolve) => setTimeout(resolve, 1000));
      }

      setItems([]);
      toast.success("Successfully Added!", {
        position: "top-center",
        autoClose: 1500,
        theme: "light",
      });

      close();
      if (fetchData) fetchData();
    } catch (e) {
      if (process.env.NODE_ENV === 'development') {
        console.error("Error saving orders:", e);
      }
      toast.error("Failed to save orders. Please try again.", {
        position: "top-center",
        autoClose: 3000,
        theme: "light",
      });
    } finally {
      savingOrdersRef.current = false;
      setIsSavingOrders(false);
    }
  }, [items, authToken, userInfo, fetchData, close]);




  const handleOpenInvoiceSelectionModal = (item) => {
    setSelectedItem(item);
    setShowInvoiceSelectionDialog(true);
  };

  const _onPreview = useCallback(async (invoiceType) => {
    if (!selectedItem || !selectedItem.party || !selectedItem.product) {
      return;
    }

    const { party, quantity, product } = selectedItem;
    const items = [
      {
        name: product.productName,
        rate: product.price,
      },
    ];

    const htmlData = {
      clientAddress: party.shippingAddress,
      clientName: party.name,
      clientGSTNo: party.gst,
      challanDate: moment().format("DD-MM-YYYY"),
      items,
      quantity,
    };

    let options = null;
    let htmlTemplate = null;

    if (invoiceType === "invoice") {
      options = {
        orientation: "p",
        unit: "pt",
        format: [850, 1066],
        putOnlyUsedFonts: true,
      };
      htmlTemplate = invoiceTemplate(htmlData);
    } else if (invoiceType === "challan1") {
      options = {
        orientation: "p",
        unit: "pt",
        format: [850, 1066],
        putOnlyUsedFonts: true,
      };
      htmlTemplate = challan1Template(htmlData);
    } else if (invoiceType === "challan2") {
      options = {
        orientation: "p",
        unit: "pt",
        format: [850, 1066],
        putOnlyUsedFonts: true,
      };
      htmlTemplate = challan2Template(htmlData);
    } else if (invoiceType === "challan3") {
      options = {
        orientation: "p",
        unit: "px",
        format: "a6",
        putOnlyUsedFonts: true,
      };
      htmlTemplate = challan3Template(htmlData);
    }

    if (!htmlTemplate) return;

    await htmlTemplateToDataString(htmlTemplate, options, (dataString) => {
      const preBlob = dataURItoBlob(dataString);
      const blobUrl = URL.createObjectURL(preBlob);
      const printWindow = window.open(blobUrl, "_blank");

      if (printWindow) {
        printWindow.addEventListener('beforeunload', () => {
          URL.revokeObjectURL(blobUrl);
        });
      } else {
        setTimeout(() => URL.revokeObjectURL(blobUrl), 100);
      }
    });
  }, [selectedItem]);

  const InvoiceSelectionDialog = () => {
    return (
      <Dialog
        onClose={() => {
          setShowInvoiceSelectionDialog(false);
          close();
        }}
        aria-labelledby="simple-dialog-title"
        open={showInvoiceSelectionDialog}
      >
        <DialogTitle id="simple-dialog-title">Select Invoice</DialogTitle>
        <List>
          {invoiceTemplates.map(({ label, value }) => (
            <ListItem
              button
              onClick={() => {
                _onPreview(value);
                setShowInvoiceSelectionDialog(false);
                close();
              }}
              key={value}
            >
              <ListItemText primary={label} />
            </ListItem>
          ))}
        </List>
      </Dialog>
    );
  };

  function _setCategoryImage(files) {
    setCategoryImage(files);
  }

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={close}
      aria-labelledby="responsive-dialog-title"
    >
      <GridContainer>
        <GridItem xs={12} sm={12}>
          <Card>
            <CardHeader color="primary">
              <Box
                display={"flex"}
                alignItems={"center"}
              >
                <h4 className={classes.cardTitleWhite}>
                  Add Prescription Order
                </h4>
                <Button color={"transparent"} onClick={() => close()}>
                  Close
                </Button>
                <Button color={"transparent"} onClick={() => _onSave()} disabled={isSavingOrders}>
                  {isSavingOrders ? "Saving…" : "Save"}
                </Button>
              </Box>
            </CardHeader>
            <CardBody>

              <GridContainer>
                <GridItem xs={12}>
                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                    <FilePicker
                      files={categoryImage}
                      buttonLabel={"Upload Prescription Order Image*"}
                      id={"Prescription Photo"}
                      maxFiles={1}
                      setNewFiles={_setCategoryImage}
                      filetype={".png,.jpg,.jpeg"}
                    />
                  </div>
                </GridItem>
                <GridItem xs={4} sm={4} md={4}>
                  <Autocomplete
                    className={classes.formControl}
                    options={labs}
                    value={lab}
                    onChange={(event, newValue) => setLab(newValue)}
                    getOptionLabel={(option) => (option.lab ? option.lab : "")}
                    id="lab"
                    loading={loadingLabs}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Lab*"
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <>
                              {loadingLabs ? <CircularProgress color="inherit" size={20} /> : null}
                              {params.InputProps.endAdornment}
                            </>
                          ),
                        }}
                      />
                    )}
                  />
                </GridItem>
                <GridItem xs={4} sm={4} md={4}>
                  <Autocomplete
                    className={classes.formControl}
                    options={productTypes}
                    value={productType}
                    onChange={(event, newValue) => setProductType(newValue)}
                    getOptionLabel={(option) =>
                      option.productType ? option.productType : ""
                    }
                    id="productType"
                    loading={loadingProductTypes}
                    disabled={!lab || loadingProductTypes}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Product Type*"
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <>
                              {loadingProductTypes ? <CircularProgress color="inherit" size={20} /> : null}
                              {params.InputProps.endAdornment}
                            </>
                          ),
                        }}
                      />
                    )}
                  />
                </GridItem>
                <GridItem xs={4} sm={4} md={4}>
                  <Autocomplete
                    className={classes.formControl}
                    options={productNames}
                    value={productName}
                    onChange={(event, newValue) => {
                      console.log("Product Name selected:", newValue);
                      setProductName(newValue || "");
                    }}
                    getOptionLabel={(option) => option || ""}
                    id="productName"
                    loading={loadingProductNames}
                    disabled={!lab || !productType || loadingProductNames}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Product Name*"
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <>
                              {loadingProductNames ? <CircularProgress color="inherit" size={20} /> : null}
                              {params.InputProps.endAdornment}
                            </>
                          ),
                        }}
                      />
                    )}
                  />
                </GridItem>
                <GridItem xs={2} sm={2} md={2}>
                  <Autocomplete
                    className={classes.formControl}
                    options={glassTypes}
                    value={glassType}
                    onChange={(event, value) => setGlassType(value)}
                    getOptionLabel={(option) => option}
                    id="glassType"
                    renderInput={(params) => (
                      <TextField {...params} label="Glass Type*" />
                    )}
                  />
                </GridItem>
                <GridItem xs={2} sm={2} md={2}>
                  <CustomInput
                    labelText="Dia"
                    id="dia"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: dia,
                      onChange: (event) => setDia(event.target.value),
                    }}
                  />
                </GridItem>
                <GridItem xs={2} sm={2} md={2}>
                  <Autocomplete
                    className={classes.formControl}
                    options={indexOptions}
                    value={index}
                    onChange={(event, value) => {
                      console.log("Index selected:", value);
                      setIndex(value || "");
                    }}
                    getOptionLabel={(option) => option || ""}
                    id="index"
                    loading={loadingIndexes}
                    disabled={!productName || loadingIndexes}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Index*"
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <>
                              {loadingIndexes ? <CircularProgress color="inherit" size={20} /> : null}
                              {params.InputProps.endAdornment}
                            </>
                          ),
                        }}
                      />
                    )}
                  />
                </GridItem>
                <GridItem xs={3} sm={3} md={3}>
                  <Autocomplete
                    className={classes.formControl}
                    options={coatings}
                    value={coat}
                    onChange={(event, value) => setCoat(value)}
                    getOptionLabel={(option) => option.coating || ""}
                    id="coat"
                    loading={loadingCoatings || loadingFinalProduct}
                    disabled={!index || loadingCoatings || loadingFinalProduct}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Coat Type*"
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <>
                              {(loadingCoatings || loadingFinalProduct) ? <CircularProgress color="inherit" size={20} /> : null}
                              {params.InputProps.endAdornment}
                            </>
                          ),
                        }}
                      />
                    )}
                  />
                </GridItem>
                <GridItem xs={3} sm={3} md={3}>
                  <Autocomplete
                    className={classes.formControl}
                    options={fittingHeightOptions}
                    value={fittingHeight}
                    onChange={(event, value) => setFittingHeight(value)}
                    getOptionLabel={(option) => option}
                    id="fittingHeight"
                    renderInput={(params) => (
                      <TextField {...params} label="Fitting Height" />
                    )}
                  />
                </GridItem>

                <GridItem xs={4} sm={4} md={3}>
                  <Autocomplete
                    className={classes.formControl}
                    options={users}
                    value={party}
                    onChange={(event, newValue) => setParty(newValue)}
                    getOptionLabel={(option) => option.name}
                    id="party"
                    renderInput={(params) => (
                      <TextField {...params} label="Party*" />
                    )}
                  />
                </GridItem>
                <GridItem xs={4} sm={4} md={3}>
                  <CustomInput
                    labelText="Party Reference"
                    id="partyRef"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: partyRef,
                      onChange: (event) => setPartyRef(event.target.value),
                    }}
                  />
                </GridItem>
                <GridItem xs={4} sm={4} md={3}>
                  <CustomInput
                    labelText="Party Mobile No."
                    id="partyMobileNo"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: partyMobileNo,
                      onChange: (event) => setPartyMobileNo(event.target.value),
                    }}
                  />
                </GridItem>
                <GridItem xs={4} sm={4} md={3}>
                  <CustomInput
                    labelText="Client Name"
                    id="clientName"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: clientName,
                      onChange: (event) => setClientName(event.target.value),
                    }}
                  />
                </GridItem>

                <GridItem xs={2} sm={2} md={2}>
                  <CustomInput
                    labelText="Prism"
                    id="prism"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: prism,
                      onChange: (event) => setPrism(event.target.value),
                    }}
                  />
                </GridItem>
                <GridItem xs={2} sm={2} md={2}>
                  <CustomInput
                    labelText="Ed"
                    id="ed"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: ed,
                      onChange: (event) => setEd(event.target.value),
                    }}
                  />
                </GridItem>
                <GridItem xs={2} sm={2} md={2}>
                  <CustomInput
                    labelText="Pd"
                    id="pd"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: pd,
                      onChange: (event) => setPd(event.target.value),
                    }}
                  />
                </GridItem>
                <GridItem xs={3} sm={3} md={3}>
                  <Autocomplete
                    className={classes.formControl}
                    options={frameSections}
                    value={frameSection}
                    onChange={(event, value) => setFrameSection(value)}
                    getOptionLabel={(option) => option}
                    id="frameSection"
                    renderInput={(params) => (
                      <TextField {...params} label="Frame Section" />
                    )}
                  />
                </GridItem>

                <GridItem xs={3} sm={3} md={3}>
                  <CustomInput
                    labelText="Pair / Quantity*"
                    id="quantity"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      type: "number",
                      value: quantity,
                      onChange: (event) => setQuantity(event.target.value),
                    }}
                  />
                </GridItem>
                <Box
                  component={Grid}
                  container
                  display={"flex"}
                  justifyContent={"center"}
                  alignItems={"center"}
                  borderRadius={5}
                  boxShadow={3}
                >
                  <GridItem xs={12} sm={12} md={2}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={tint}
                          onChange={(e) => setTint(e.target.checked)}
                          name="tint"
                          color={"primary"}
                        />
                      }
                      label="Tint"
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={2}>
                    <CustomInput
                      id="sphRight"
                      labelText="Right sph*"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        value: sphRight,
                        onChange: (event) => setSphRight(event.target.value),
                      }}
                    />
                  </GridItem>

                  <GridItem xs={12} sm={12} md={1}>
                    <CustomInput
                      id="cylRight"
                      labelText="Right cyl*"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        value: cylRight,
                        onChange: (event) => setCylRight(event.target.value),
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={1}>
                    <CustomInput
                      id="axisRight"
                      labelText="Right axis*"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        value: axisRight,
                        onChange: (event) => setAxisRight(event.target.value),
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={1}>
                    <CustomInput
                      id="addRight"
                      labelText="Right add*"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        value: addRight,
                        onChange: (event) => setAddRight(event.target.value),
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={1}>
                    <CustomInput
                      id="sphLeft"
                      labelText="Left sph*"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        value: sphLeft,
                        onChange: (event) => setSphLeft(event.target.value),
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={1}>
                    <CustomInput
                      id="cylLeft"
                      labelText="Left cyl*"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        value: cylLeft,
                        onChange: (event) => setCylLeft(event.target.value),
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={1}>
                    <CustomInput
                      id="axisLeft"
                      labelText="Left axis*"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        value: axisLeft,
                        onChange: (event) => setAxisLeft(event.target.value),
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={1}>
                    <CustomInput
                      id="addLeft"
                      labelText="Left add*"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        value: addLeft,
                        onChange: (event) => setAddLeft(event.target.value),
                      }}
                    />
                  </GridItem>

                  <GridItem xs={12} sm={12} md={1}>
                    <Box justifyContent={"center"} marginTop={4}>
                      <Fab
                        size={"small"}
                        color="primary"
                        aria-label="add"
                        onClick={() => {
                          console.log("Add icon clicked");
                          console.log("Current values - productName:", productName, "index:", index, "coating:", coat);
                          if (
                            lab === null ||
                            productType === null ||
                            productName === "" ||
                            party === null ||
                            glassType === "" ||
                            index === "" ||
                            quantity === "" ||
                            sphRight === "" ||
                            sphLeft === "" ||
                            cylRight === "" ||
                            cylLeft === "" ||
                            axisRight === "" ||
                            axisLeft === "" ||
                            addRight === "" ||
                            addLeft === "" ||
                            coat === ""
                          ) {
                            toast.error("Please fill all the required fields", {
                              position: "top-center",
                              autoClose: 1500,
                              hideProgressBar: false,
                              closeOnClick: true,
                              pauseOnHover: true,
                              draggable: true,
                              progress: undefined,
                              theme: "light",
                            });
                            return;
                          }

                          // Use productDetails if available, otherwise show error
                          if (!productDetails || !productDetails.price) {
                            toast.error("Product details not available. Please wait for product details to load.", {
                              position: "top-center",
                              autoClose: 2000,
                              theme: "light",
                            });
                            return;
                          }

                          const productMain = productDetails;

                          const orderAmount = Number(productMain.price) * Number(quantity);
                          const imagePath = categoryImage.length ? categoryImage[0].path : "";

                          const object = {
                            orderType: "Prescription",
                            party: {
                              accountCode: party.accountCode,
                              accountId: party._id,
                              accountName: party.name,
                              accountAddress: party.address,
                              accountGst: party.gst,
                              balanceLock: party.balanceLock,
                              runningChallanBalance: party.runningChallanBalance,
                              runningBillBalance: party.runningBillBalance,
                            },
                            orderDetail: {
                              lab: lab ? lab.lab : "",
                              partyRef,
                              partyMobileNo,
                              clientName,
                              product: productMain,
                              productName: productMain.productName,
                              productType: productMain.productType || "",
                              glassType,
                              dia,
                              index,
                              coat: coat ? coat.coating : "",
                              fittingHeight,
                              prism,
                              ed,
                              pd,
                              frameSection,
                              quantity,
                              note: note,
                              tint,
                              rSph: sphRight,
                              rCyl: cylRight,
                              rAxis: axisRight,
                              rAddition: addRight,
                              lSph: sphLeft,
                              lCyl: cylLeft,
                              lAxis: axisLeft,
                              lAddition: addLeft,
                            },
                            orderAmount,
                            price: productMain.price,
                            quantity,
                            createdBy: userInfo._id,
                            createdByName: userInfo.name,
                            orderAdminStatus: "Confirmed",
                            image: imagePath,
                          };

                          setCategoryImage([]);
                          setItems(prevItems => [...prevItems, object]);

                          // Batch state updates using React's automatic batching
                          setLab(null);
                          setParty(null);
                          setProductName("");
                          setProductNames([]);
                          setProductType(null);
                          setIndexOptions([]);
                          setCoatings([]);
                          setProductDetails(null);
                          setPartyRef("");
                          setPartyMobileNo("");
                          setClientName("");
                          setGlassType("");
                          setDia("");
                          setIndex("");
                          setCoat("");
                          setFittingHeight("");
                          setPrism("");
                          setEd("");
                          setPd("");
                          setFrameSection("");
                          setQuantity("");
                          setTint(false);
                          setSphRight("");
                          setCylRight("");
                          setAxisRight("");
                          setAddRight("");
                          setSphLeft("");
                          setCylLeft("");
                          setAxisLeft("");
                          setAddLeft("");
                        }}
                      >
                        <AddIcon />
                      </Fab>
                    </Box>
                  </GridItem>
                  {_.isEmpty(items) ? null : (
                    <GridItem xs={12}>
                      <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                          <TableRow>
                            {columns.map((column) => (
                              <TableCell
                                key={column.id}
                                align={"center"}
                                style={{ minWidth: column.minWidth }}
                              >
                                {column.label}
                              </TableCell>
                            ))}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {items.map((row, index) => {
                            return (
                              <TableRow
                                hover
                                role="checkbox"
                                tabIndex={-1}
                                key={`order-${index}-${row.orderDetail?.productName || index}`}
                              >
                                {columns.map((column) => {
                                  let value = row.orderDetail[column.id];
                                  if (column.id === "product") {
                                    value = row.orderDetail?.product
                                      ?.productName
                                      ? row.orderDetail.product.productName
                                      : "";
                                  }
                                  if (column.id === "party") {
                                    value = row.party.accountName;
                                  }
                                  if (column.id === "action") {
                                    return (
                                      <TableCell align={"center"}>
                                        <Box
                                          display={"flex"}
                                          justifyContent={"center"}
                                        >
                                          <IconButton
                                            aria-label="delete"
                                            onClick={() => {
                                              setItems(prevItems => prevItems.filter((_, i) => i !== index));
                                            }}
                                          >
                                            <DeleteIcon />
                                          </IconButton>
                                        </Box>
                                      </TableCell>
                                    );
                                  }
                                  return (
                                    <TableCell key={column.id} align={"center"}>
                                      {value}
                                    </TableCell>
                                  );
                                })}
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </GridItem>
                  )}
                </Box>

                <GridItem xs={12} sm={12} md={12}>
                  <CustomInput
                    labelText={"Notes"}
                    id="note"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      rows: 3,
                      multiline: true,
                      value: note,
                      onChange: (event) => setNote(event.target.value),
                    }}
                  />
                </GridItem>
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
      <InvoiceSelectionDialog />
    </Dialog>
  );
}